import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import 'semantic-ui-css/components/table.min.css';
import { Button, Icon, Table } from 'semantic-ui-react';
import MyList from './list';

interface ListProps {

}

interface ListState {
    data: any[],
    errorMsg: string
}

class ClientList extends MyList {
    entity = "client"

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect}/>
        }
        return (
            <section className="full-width">
                <h2>Хэрэглэгчийн жагсаалт</h2>

                {this.state.errorMsg ? <div className="error-msg">
                    <Icon name="warning circle"/>&nbsp;
                    {this.state.errorMsg}
                </div> : null}

                <Table striped className="admin-list-table" width={16}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>№</Table.HeaderCell>
                            <Table.HeaderCell>Овог нэр</Table.HeaderCell>
                            <Table.HeaderCell>Имэйл</Table.HeaderCell>
                            <Table.HeaderCell>Утас</Table.HeaderCell>
                            <Table.HeaderCell>Идэвхитэй</Table.HeaderCell>
                            <Table.HeaderCell></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        { this.state?.data?.map((row: any, index: number) => {
                                return <Table.Row key={row.id}>
                                    <Table.Cell data-label="№">{ String(index+1) }</Table.Cell>
                                    <Table.Cell data-label="Овог нэр">
                                        <strong>
                                            <Link className="underline hover-blue" to={"/mongol/client/" + row.id}>
                                                { row.parentName } { row.ownName }
                                            </Link>
                                        </strong>
                                    </Table.Cell>
                                    <Table.Cell data-label="Имэйл">{ row.email }</Table.Cell>
                                    <Table.Cell data-label="Утас">{ row.phone }</Table.Cell>
                                    <Table.Cell data-label="Идэвхитэй"> { row.active ? <Icon name="checkmark"/> : null } </Table.Cell>
                                    <Table.Cell data-label="Үйлдэл">
                                        { row.confirmingDelete ? 
                                            <React.Fragment>
                                                <Button primary size='mini' onClick={() => this.delete(index)}>Устга</Button>
                                                <Button size='mini' onClick={() => this.toggleDelete(index)}>Болих</Button>
                                            </React.Fragment> :
                                            <Icon name="trash" className="cursor chef-icon-hover padding-5" onClick={() => this.toggleDelete(index)}/>
                                        }
                                    </Table.Cell>
                                </Table.Row>
                            })
                        }
                    </Table.Body>
                </Table>
            </section>
        );
    }
}
            
export default ClientList;